"use strict";

exports.__esModule = true;
exports.Content = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Simple content wrapper providing a standard margin.
 * Useful for displaying blocks of content within containers with borders or backgrounds.
 * @component
 */
var Content = exports.Content = _styledComponents["default"].div.withConfig({
  displayName: "Content",
  componentId: "sc-10r0eml-0"
})(["margin:1rem;"]);